import RestApiModel from "@/api/Model/RestApiModel";
import store from '@/store/store'
import api from "@/api";
import Vue from 'vue';

class Persona extends RestApiModel {
  static getResourceEndpoint() {
    return '/persona/orion';
  }

  static listAvailableRoles(personaId) {
    return api.post(`${this.getResourceEndpoint()}/available-roles`, { personaId });
  }

  static canAccess(params = {}) {
    params.name = params.name.replace(/\./g, '_');

    return api.post(`${this.getResourceEndpoint()}/access`, params);
  }

  static privileges(params = {}) {
    return api.get(`${this.getResourceEndpoint()}/privileges`, params);
  }

  static isSystem(params = {}) {
    return api.get(`${this.getResourceEndpoint()}/is-system`, params);
  }
}

export default Persona;
